module.exports = __webpack_public_path__ + "static/media/zip-file.5d4fd336.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zip-file.svg
// module id = 473
// module chunks = 0 1